'use client';

import {useState, useEffect} from 'react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('utss_cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = (value: string) => {
    localStorage.setItem('utss_cookie_consent', value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-4 bg-white border-t shadow-lg">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center gap-4">
        <p className="text-sm text-gray-600 flex-1">
          Ce site utilise des cookies pour améliorer votre expérience et mesurer l&apos;audience.
          En continuant, vous acceptez notre{' '}
          <a href="/fr/confidentialite" className="text-primary underline">politique de confidentialité</a>.
        </p>
        <div className="flex gap-2 shrink-0">
          <button onClick={() => accept('essential')}
            className="px-4 py-2 text-sm border rounded-lg hover:bg-gray-50 cursor-pointer">
            Essentiels uniquement
          </button>
          <button onClick={() => accept('all')}
            className="px-4 py-2 text-sm bg-primary text-white rounded-lg hover:bg-primary/90 cursor-pointer">
            Tout accepter
          </button>
        </div>
      </div>
    </div>
  );
}
